/* eslint-disable @typescript-eslint/ban-ts-comment */
import Avatar from "../../assets/Avatar.png";
import CoursePlaceholder from "../../assets/CoursePlaceholder.png";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getUserCountry, hasDiscount } from "../../utils/utils";
import ReactMarkdown from 'react-markdown';
import { Book } from "../../types/types";
import Button from "../Shared/Button";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../main";
import { getApiErrorMessage } from "../../utils/apiError";
import { toast } from "react-toastify";
import { AddBookToCart } from "../../api/Cart/AddBookToCart";
import { useUserDataStore } from "../../stores/user";
import { getAccessToken } from "../../lib/session";

interface BookCardProps {
  book: Book;
}

const BookCard = ({ book }: BookCardProps) => {
  const navigate = useNavigate()

  const [showFullDescription] = useState(false);
  const descriptionWords = book.description.split(" ");
  const { userData } = useUserDataStore();
  const truncatedDescription = showFullDescription
    ? descriptionWords.join(" ")
    : descriptionWords.slice(0, 25).join(" ");
  const [country, setCountry] = useState<string | null>(null);
  const { mutate } = useMutation({
    //@ts-expect-error
    mutationFn: () => AddBookToCart(book.id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cart"] });
    },
    onError: (error: unknown) => {
      toast.error(getApiErrorMessage(error, "Error Adding To Cart"));
    },
  });

  useEffect(() => {
    const userCountry = getUserCountry();
    setCountry(userCountry);
  }, []);
  const handleBuyNowClick = () => {
    const accessToken = getAccessToken();
    if (accessToken) {
      mutate();
    } else {
      navigate("/login?cart=true");
    }
  };


  return (
    <div className="relative flex flex-col justify-between h-full p-4 bg-white border rounded-2xl border-black/20">
      <div className="relative mb-4">
        <Link to={`/book/${book.slug}`}>
          <img
            className="max-h-[225px] w-full h-full object-fit rounded-lg border-[#C4C4C4]/15 border"
            src={book.img_url || CoursePlaceholder}
            alt="Course"
          />
        </Link>
        {(
          country === 'EG' ? (
            hasDiscount(book.public_EGP_price, book.discountPrice_egp) && (
              <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                {book.public_EGP_price} EGP
              </div>
            )
          ) : (
            hasDiscount(book.public_USD_price, book.discountPrice_usd) && (
              <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                {book.public_USD_price} USD
              </div>
            )
          )
        )}

      </div>
      <div>
        <div className="flex justify-between w-full items-center mb-3 py-0.5">
          <h1 className="text-lg font-semibold md:text-2xl sm:text-xl">{book.name}</h1>
          <div className="rounded py-1.5 min-w-[90px] px-3 flex justify-center md:text-base text-sm items-center gap-0.5 font-bold bg-primary text-white">
            {country === 'EG' ? (
              <>
                {hasDiscount(book.public_EGP_price, book.discountPrice_egp) ? book.discountPrice_egp : book.public_EGP_price} <span className="text-xs uppercase md:text-sm">EGP</span>
              </>
            ) : (
              <>
                {hasDiscount(book.public_USD_price, book.discountPrice_usd) ? book.discountPrice_usd : book.public_USD_price} <span className="text-xs uppercase md:text-sm">USD</span>
              </>
            )}
          </div>
        </div>
        <div className="mb-4 ">
          <span className="text-sm font-medium text-lightGray/70">
            <ReactMarkdown>{truncatedDescription}</ReactMarkdown>
          </span>
          {!showFullDescription && (
            <Link
              className="text-sm font-bold text-primary"
              to={`/book/${book.slug}`}
            >
              {" "}
              &nbsp; Learn more about {book.name}
            </Link>
          )}
        </div>
        <div className="flex items-center gap-2 mb-4">
          <img
            src={book.author?.photo || Avatar}
            className="max-w-5 max-h-5 w-full h-full object-cover rounded-full object-[75%_25%]"
            alt="Instructor Avatar"
          />
          <h1 className="text-[#1D1D1F] font-medium text-xs">
            {book.author?.firstName} {book.author?.lastName}{" "}
            <span className="opacity-70">from</span> {book.author?.city},{" "}
            {book.author?.country}
          </h1>
        </div>
        <div className="flex gap-2">
          <Link className="w-full" to={`/book/${book.slug}`}>
            <Button
              variant="primary"
              className="md:h-9 h-8 !rounded-lg font-semibold text-xs w-full"
            >
              View Book
            </Button>
          </Link>
          <Button
            variant="gray"
            className="md:h-9 h-8 !rounded-lg font-semibold text-xs w-full"
            onClick={handleBuyNowClick}
            disabled={userData.role === "sales"}
          >
            Add To Cart
          </Button>
        </div>

      </div>
    </div>
  );
};

export default BookCard;
